export enum TipPromptBehavior {
  ALWAYS = "ALWAYS",
  ON_LONG_PRESS = "ON_LONG_PRESS",
  OFF = "OFF",
}
